var _desc, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Users") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Users")), /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Facilities",
    transform: "translate(-58.000000, -254.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(58.000000, 174.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    style: {
      mixBlendMode: "luminosity"
    },
    transform: "translate(0.000000, 80.000000)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FABDF2",
    cx: 12,
    cy: 12,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2,10.8 C6.13961328,10.8 5.28,9.94038672 5.28,8.88 C5.28,7.81961328 6.13961328,6.96 7.2,6.96 C8.26038672,6.96 9.12,7.81961328 9.12,8.88 C9.12,9.94038672 8.26038672,10.8 7.2,10.8 Z M7.2,11.28 C9.3207552,11.28 11.04,12.3305554 11.04,13.6263863 L11.04,14.6391897 C11.04,14.9060016 10.8249094,15.12 10.5595816,15.12 L3.84041839,15.12 C3.57342281,15.12 3.36,14.9047339 3.36,14.6391897 L3.36,13.6263863 C3.36,12.3305554 5.0792448,11.28 7.2,11.28 Z M16.8,10.8 C15.7396133,10.8 14.88,9.94038672 14.88,8.88 C14.88,7.81961328 15.7396133,6.96 16.8,6.96 C17.8603867,6.96 18.72,7.81961328 18.72,8.88 C18.72,9.94038672 17.8603867,10.8 16.8,10.8 Z M16.8,11.28 C18.9207552,11.28 20.64,12.3305554 20.64,13.6263863 L20.64,14.6391897 C20.64,14.9060016 20.4249094,15.12 20.1595816,15.12 L13.4404184,15.12 C13.1734228,15.12 12.96,14.9047339 12.96,14.6391897 L12.96,13.6263863 C12.96,12.3305554 14.6792448,11.28 16.8,11.28 Z",
    id: "Shape",
    fill: "#F68FE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,12 C10.5419683,12 9.36,10.8180317 9.36,9.36 C9.36,7.90196827 10.5419683,6.72 12,6.72 C13.4580317,6.72 14.64,7.90196827 14.64,9.36 C14.64,10.8180317 13.4580317,12 12,12 Z M12,12.72 C14.9160384,12.72 17.28,14.0934391 17.28,15.7875381 L17.28,17.0420111 C17.28,17.3040854 17.0645676,17.52 16.7988184,17.52 L7.20118159,17.52 C6.93572522,17.52 6.72,17.3059971 6.72,17.0420111 L6.72,15.7875381 C6.72,14.0934391 9.0839616,12.72 12,12.72 Z",
    id: "Shape",
    fill: "#9D59B8"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.71d591740cdb74ac21499be5a89b74d5.svg";
export { ForwardRef as ReactComponent };